import { autoinject } from "aurelia-framework";
import { ConfigService } from "./config.service";
import moment from "moment";

@autoinject
export class NotificationClientService {

    private _showFuncs: ((x: NotificationModel) => void)[] = [];
    private _hideFuncs: (() => void)[] = [];

    constructor(private configService: ConfigService) { }

    // SHOW DIALOG FUNCTIONS
    public subscribeShow(funcShow: (x: NotificationModel) => void) {
        const index = this._showFuncs.indexOf(funcShow);
        if (index < 0) {
            this._showFuncs.push(funcShow);
        }
    }

    public unSubscribeShow(showFunc: (x: NotificationModel) => void) {
        const index = this._showFuncs.indexOf(showFunc);
        if (index > -1) {
            this._showFuncs.splice(this._showFuncs.indexOf(showFunc), 1);
        }
    }

    public show(title: string, description: string, notificationType: NotificationType, 
        time: number = Number(this.configService.config.common.defaultNotificationTimeout), actionText: string = null, actionHandler: (x: any) => void = null, persistInServer: boolean = false, linkActionText: string = null, linkActionHandler: (x: any) => void = null) {
        for (const func of this._showFuncs) {
            func({
                title: title,
                description: description,
                notificationType: notificationType,
                time: time,
                isHidden: false,
                actionText: actionText,
                hasBeenSeen: false,
                actionHandler: actionHandler,
                persistInServer: persistInServer,
                date: moment(new Date()).format(this.configService.config.common.defaultDateTimeFormat),
                linkActionText: linkActionText,
                linkActionHandler: linkActionHandler
            });
        }
    }

    // HIDE DIALOG FUNCTIONS
    public subscribeHide(funcHide: () => void) {
        this._hideFuncs.push(funcHide);
    }

    public unSubscribeHide(funcHide: () => void) {
        this._hideFuncs.splice(this._hideFuncs.indexOf(funcHide), 1);
    }

    public hide() {
        for (const func of this._hideFuncs) {
            func();
        }
    }

}

export enum NotificationType {
    Info = 1,
    Success = 2,
    Warning = 3,
    Error = 4,
}

export class NotificationModel {
    title: string;
    description: string;
    notificationType: NotificationType;
    time: number;
    actionText: string;
    isHidden: boolean;
    actionHandler: (x: any) => void;
    persistInServer: boolean;
    date: string;
    hasBeenSeen?: boolean;
    seenFirstTime?: boolean;
    linkActionText?: string;
    linkActionHandler?: (x: any) => void;
}
